<mat-card style="background-color:#003057; border: none" class="mat-elevation-z10">
  <mat-card-content>
    <div class="form-bg" *ngIf="!preference">
      <div *ngIf="errorMessageIntialData == ''"
        class="d-flex justify-content-center alert alert-warning alert-dismissible fade show" role="alert">
        <div *ngIf="errorMessageIntialData == ''">
          Loading...
          <div class="spinner-border text-primary" role="status"></div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    </div>
    <div *ngIf="errorMessage != ''"
      class="d-flex justify-content-center alert alert-danger alert-dismissible fade show fs-3" role="alert"
      (closed)="errorMessage = ''">
      <i class="bi bi-exclamation-triangle-fill px-2"></i>
      <div [innerHTML]="errorMessage"></div>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div *ngIf="successMessage != ''"
      class="d-flex justify-content-center alert alert-success alert-dismissible fade show fs-3" role="alert"
      (closed)="successMessage = ''">
      <i class="bi bi-check-circle-fill px-2"></i>

      <div [innerHTML]="successMessage"></div>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div *ngIf="warningMessage != ''"
      class="d-flex justify-content-center alert alert-warning alert-dismissible fade show fs-3" role="alert"
      (closed)="warningMessage = ''">
      <i class="bi bi-exclamation-triangle-fill px-2"></i>

      <div [innerHTML]="warningMessage"></div>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div *ngIf="!isValidFormSubmitted">
      <div class="form-bg" *ngIf="preference">
        <div class="row">
          <app-timer-la [resetTime]="timerReset" [isValidFormSubmitted]="isValidFormSubmitted"
            (changeResetMessageCalled)="changeResetMessage()"></app-timer-la>
        </div>
        <form focusFirstInvalidField #customerForm="ngForm" name="customerForm" class="customer-form" novalidate>
          <div class="container-fluid">
            <!-- <div class="row">
              <div class="col text-center text-white fw-bold">
                Time left: <span class="count">{{ display }}</span>
              </div>
            </div> -->
            <div class="row">
              <div class="col fw-bold" style="color: yellow">
                *These are required fields. Make sure you fill in these boxes.
              </div>
            </div>
            <mat-horizontal-stepper linear #stepper class="rounded" style="border: 2px solid hsl(187, 40%, 56%)" aria-busy="true">
              <mat-step label="Policyholder Info" aria-label="Create Policyholder Info" [completed]="policyHolderCheck()">
                <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
                  <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
                    Apply Now
                  </legend>

                  <input type="hidden" name="existingMember" [(ngModel)]="existingMember" #existingMembers="ngModel"
                    style="display: none" />
                  <mat-card *ngIf="existingMember == null" class="mat-elevation-z8">
                    <mat-card-content>
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>First Name<ng-container *ngIf="!firstNameRequired">*</ng-container></mat-label>

                            <input matInput type="text" name="memberVO.firstNm" [(ngModel)]="memberObj1.firstNm"
                              uppercase #memberVOfirstNm="ngModel"
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              maxlength="20" (keypress)="
                                allowAlphabets2($event, memberVOfirstNm)
                              " (blur)="nomatchCheck($event, memberVOfirstNm)" [required]="firstNameRequired"
                              #memberVO.firstNm="ngModel" />
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['required'] && !memberVOfirstNm.errors?.['nomatch']">First
                              Name is required</mat-error>
                            <mat-error *ngIf="memberVOfirstNm.errors?.['invalid']">First Name is invalid</mat-error>
                            <mat-error *ngIf="memberVOfirstNm.errors?.['pattern']">First Name is invalid</mat-error>
                            <mat-error *ngIf="memberVOfirstNm.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and
                              Apostrophe
                              are allowed.</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Last Name<ng-container *ngIf="!lastNameRequired">*</ng-container></mat-label>
                            <input matInput type="text" name="memberVO.lastNm" [(ngModel)]="memberObj1.lastNm" uppercase
                              maxlength="25"
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              #memberVOLastNm="ngModel" (keypress)="
                                allowAlphabets2($event, memberVOLastNm)
                              " (blur)="nomatchCheck($event, memberVOLastNm)" [required]="lastNameRequired" />
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['required'] && !memberVOLastNm.errors?.['nomatch']">Last
                              Name is required</mat-error>
                            <mat-error *ngIf="memberVOLastNm.errors?.['invalid']">Last Name is invalid</mat-error>
                            <mat-error *ngIf="memberVOLastNm.errors?.['pattern']">Last Name is invalid</mat-error>
                            <mat-error *ngIf="memberVOLastNm.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and
                              Apostrophe
                              are allowed.</mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Social Security Number<ng-container
                                *ngIf="!ssnMemberRequired">*</ng-container></mat-label>
                            <input matInput type="text" name="memberObj.ssnNum" [(ngModel)]="memberObj1.ssnNum" (input)="
                                memberObj1.ssnNum = ssnmask($event, MemberSsn)
                              " maxlength="11" #MemberSsn="ngModel" (blur)="verifySSN($event, false,MemberSsn)"
                              [required]="ssnMemberRequired" pattern="^\d{3}-\d{2}-\d{4}$"
                              (keypress)="isNumeric($event, MemberSsn)" />
                            <mat-error *ngIf="MemberSsn.errors?.['required'] && !MemberSsn.errors?.['nomatch']">Social
                              Security Number is required</mat-error>
                            <mat-error *ngIf="MemberSsn.errors?.['invalidSsn']">Social Security Number is
                              invalid</mat-error>
                            <mat-error *ngIf="MemberSsn.errors?.['pattern']">
                              <ng-container *ngIf="memberObj1.ssnNum.length < 11">Social Security Number length is
                                short</ng-container>
                              <ng-container *ngIf="memberObj1.ssnNum.length > 10">Social Security Number is
                                invalid</ng-container>
                            </mat-error>
                            <mat-error *ngIf="MemberSsn.errors?.['recordPresent']">{{ getSSNUsedMessage() }}</mat-error>
                            <mat-error *ngIf="MemberSsn.errors?.['nomatch']">Only numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Date of Birth<ng-container
                                *ngIf="!memberDobRequired">*</ng-container></mat-label>
                            <input matInput [min]="prev100year" [max]="today" [matDatepicker]="picker" name="d1"
                              #c1="ngModel" [(ngModel)]="memberVOdobDt" [required]="memberDobRequired" minlength="8"
                              maxlength="10" placeholder="MMDDYYYY" (input)="datemask2($event, c1)"
                              (blur)="parseDate($event, c1)" (keypress)="onlyNumeric($event, c1)" />

                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="c1.errors?.['required'] && !c1.errors?.['nomatch']">Date of Birth is
                              required</mat-error>
                            <mat-error *ngIf="c1.errors?.['invalid']">Date of Birth is invalid</mat-error>
                            <mat-error *ngIf="c1.errors?.['matDatepickerMin']">Date of Birth is out of range</mat-error>
                            <mat-error *ngIf="c1.errors?.['matDatepickerMax']">Date of Birth is out of range</mat-error>
                            <mat-error *ngIf="c1.errors?.['nomatch']">Only numerical values are allowed</mat-error>
                            <mat-error *ngIf="c1.errors?.['invalidDate']">Date of Birth is invalid</mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col text-center">
                          <mat-error *ngIf="errorMessage != ''">{{
                            errorMessage
                            }}</mat-error>
                          <button id="verifyMemberId" mat-raised-button color="primary" matStepperNext type="button"
                            class="m-1" (click)="verifyMemberFn(c1)">
                            Verify Member
                          </button>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>

                  <br *ngIf="existingMember == null" />
                  <mat-card *ngIf="existingMember == 'Yes'" class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle><mat-label><strong>Select one:
                            <span class="text-danger">*</span></strong></mat-label></mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                      <mat-radio-group #group color="primary" aria-label="Select an option" [(ngModel)]="updateReason"
                        [required]="updateReasonRequired" name="updateReason" #updateReasons="ngModel"
                        class="example-radio-group">
                        <mat-radio-button value="CHANGE" [required]="updateReasonRequired" class="example-radio-button">
                          I am reporting a change in my LaHIPP case
                        </mat-radio-button>
                        <mat-radio-button value="RECERT" [required]="updateReasonRequired" class="example-radio-button">
                          I am completing my renewal
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="updateReasons.errors?.['required'] && customerForm.submitted">Your response is
                        required</mat-error>
                    </mat-card-content>
                  </mat-card>

                  <div *ngIf="existingMember != null">
                    <div *ngIf="existingMember == 'No'" class="row">
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label class="fw-bold">How did you hear about LaHIPP?<ng-container
                              *ngIf="!refferalSourceRequired">*</ng-container></mat-label>
                          <select matNativeControl required name="caseVO.referralSource"
                            [required]="refferalSourceRequired" [(ngModel)]="formLa.referralCase.referralSource"
                            #referralSource="ngModel">
                            <ng-container *ngIf="preference.dropDownValues != null">
                              <option *ngFor="
                                  let info of preference.dropDownValues[
                                    'OSRCCD'
                                  ] | keyvalue : originalOrder
                                " [value]="info.key">
                                {{ info.value }}
                              </option>
                            </ng-container>
                          </select>
                          <mat-error *ngIf="referralSource.errors?.['required']">Source is required</mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col"></div>
                    </div>
                    <br *ngIf="existingMember == 'Yes'" />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle><strong>Tell us about the Policyholder of the Employer
                            Sponsored Health Insurance or Independent Health
                            Insurance policy.</strong></mat-card-subtitle>
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>First Name<ng-container *ngIf="!firstNameRequired">*</ng-container></mat-label>

                              <input matInput type="text" name="memberVO.firstNm" [(ngModel)]="memberObj1.firstNm"
                                uppercase #memberVOfirstNm="ngModel"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                maxlength="20" (keypress)="
                                  allowAlphabets2($event, memberVOfirstNm)
                                " (blur)="nomatchCheck($event, memberVOfirstNm)" [required]="firstNameRequired"
                                #memberVO.firstNm="ngModel" id="memberFirstName" />
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['required'] && !memberVOfirstNm.errors?.['nomatch']">First
                                Name is required</mat-error>
                              <mat-error *ngIf="memberVOfirstNm.errors?.['invalid']">First Name is invalid</mat-error>
                              <mat-error *ngIf="memberVOfirstNm.errors?.['pattern']">First Name is invalid</mat-error>
                              <mat-error *ngIf="memberVOfirstNm.errors?.['nomatch']">Only Alphabetical, Space, Hyphen,
                                and
                                Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>MI</mat-label>
                              <input matInput type="text" name="memberVO.miNm" [(ngModel)]="memberObj1.miNm" uppercase
                                maxlength="1" #memberVOMi="ngModel" (keypress)="
                                  allowOnlyOneAlphabet($event, memberVOMi)
                                " />
                              <mat-error *ngIf="memberVOMi.errors?.['invalid']">Middle Name is invalid</mat-error>
                              <mat-error *ngIf="memberVOMi.errors?.['nomatch']">Only Alphabet is allowed</mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Last Name<ng-container *ngIf="!lastNameRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="memberVO.lastNm" [(ngModel)]="memberObj1.lastNm"
                                uppercase maxlength="25"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                #memberVOLastNm="ngModel" (keypress)="
                                  allowAlphabets2($event, memberVOLastNm)
                                " (blur)="nomatchCheck($event, memberVOLastNm)" [required]="lastNameRequired" />
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['required'] && !memberVOLastNm.errors?.['nomatch']">Last
                                Name is required</mat-error>
                              <mat-error *ngIf="memberVOLastNm.errors?.['invalid']">Last Name is invalid</mat-error>
                              <mat-error *ngIf="memberVOLastNm.errors?.['pattern']">Last Name is invalid</mat-error>
                              <mat-error *ngIf="memberVOLastNm.errors?.['nomatch']">Only Alphabetical, Space, Hyphen,
                                and
                                Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Suffix</mat-label>
                              <select matNativeControl name="memberVO.suffixNm" [(ngModel)]="memberObj1.suffixNm">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                                      let suffix of preference.dropDownValues[
                                        'SUFFIX'
                                      ] | keyvalue : originalOrder
                                    " [value]="suffix.key">
                                    {{ suffix.value }}
                                  </option>
                                </ng-container>
                              </select>
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Social Security Number<ng-container
                                  *ngIf="!ssnMemberRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="memberObj.ssnNum" [(ngModel)]="memberObj1.ssnNum"
                                (input)="
                                  memberObj1.ssnNum = ssnmask($event, MemberSsn)
                                " maxlength="11" #MemberSsn="ngModel" (blur)="verifySSN($event, false,MemberSsn)"
                                [required]="ssnMemberRequired" pattern="^\d{3}-\d{2}-\d{4}$"
                                (keypress)="isNumeric($event, MemberSsn)" readonly />
                              <mat-error *ngIf="MemberSsn.errors?.['required'] && !MemberSsn.errors?.['nomatch']">Social
                                Security Number is required</mat-error>
                              <mat-error *ngIf="MemberSsn.errors?.['invalidSsn']">Social Security Number is
                                invalid</mat-error>
                              <mat-error *ngIf="MemberSsn.errors?.['pattern']">
                                <ng-container *ngIf="memberObj1.ssnNum.length < 11">Social Security Number length is
                                  short</ng-container>
                                <ng-container *ngIf="memberObj1.ssnNum.length > 10">Social Security Number is
                                  invalid</ng-container>
                              </mat-error>
                              <mat-error *ngIf="MemberSsn.errors?.['recordPresent']">{{ getSSNUsedMessage()
                                }}</mat-error>
                              <mat-error *ngIf="MemberSsn.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Date of Birth<ng-container
                                  *ngIf="!memberDobRequired">*</ng-container></mat-label>
                              <input matInput [min]="prev100year" [max]="today" [matDatepicker]="picker" name="d1"
                                #c1="ngModel" [(ngModel)]="memberVOdobDt" [required]="memberDobRequired" minlength="8"
                                maxlength="10" placeholder="MMDDYYYY" (input)="datemask2($event, c1)"
                                (blur)="parseDate($event, c1)" (keypress)="onlyNumeric($event, c1)" readonly />

                              <mat-datepicker-toggle matIconSuffix [for]="picker" disabled></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                              <mat-error *ngIf="c1.errors?.['required'] && !c1.errors?.['nomatch']">Date of Birth is
                                required</mat-error>
                              <mat-error *ngIf="c1.errors?.['invalid']">Date of Birth is invalid</mat-error>
                              <mat-error *ngIf="c1.errors?.['matDatepickerMin']">Date of Birth is out of
                                range</mat-error>
                              <mat-error *ngIf="c1.errors?.['matDatepickerMax']">Date of Birth is out of
                                range</mat-error>
                              <mat-error *ngIf="c1.errors?.['nomatch']">Only numerical values are allowed</mat-error>
                              <mat-error *ngIf="c1.errors?.['invalidDate']">Date of Birth is invalid</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Sex<ng-container *ngIf="!memberSexRequired">*</ng-container></mat-label>
                              <select matNativeControl name="memberVO.gencdRf" [(ngModel)]="memberObj1.gencd"
                                #memberObjGencdRf="ngModel" [required]="memberSexRequired" (change)="isGenderChange()">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                                      let g of preference.dropDownValues[
                                        'SEX'
                                      ] | keyvalue : originalOrder
                                    " [value]="g.key">
                                    {{ g.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error *ngIf="memberObjGencdRf.errors?.['required']">Sex is required</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <mat-label>Is this person a Medicaid recipient?
                              <span class="text-danger">*</span></mat-label>

                            <mat-radio-group #group color="primary" aria-label="Select an option"
                              [(ngModel)]="isMemberMedicaid" [required]="memberMedicateRequired" name="isMemberMedicaid"
                              (change)="isMedicaidMember()" #isMedicated="ngModel">
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                            </mat-radio-group>

                            <mat-error *ngIf="isMedicated.errors?.['required'] && customerForm.submitted">Your response
                              is required</mat-error>
                          </div>
                          <div class="col" *ngIf="isMemberMedicaid == 'Yes'">
                            <mat-form-field appearance="outline">
                              <mat-label>Medicaid ID Number<ng-container
                                  *ngIf="!maNumRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="memberVO.maNum" [(ngModel)]="memberObj1.maNum" uppercase
                                maxlength="13" pattern="^\d{13}$" #memberVOmaNum="ngModel"
                                (keypress)="isNumeric($event, memberVOmaNum)" [required]="maNumRequired"
                                (blur)="isMedicaidValid($event, memberVOmaNum)" />
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['required'] && !memberVOmaNum.errors?.['nomatch']">Medicaid
                                ID Number is required</mat-error>
                              <mat-error *ngIf="memberVOmaNum.errors?.['pattern']">Medicaid ID Number is
                                invalid</mat-error>
                              <mat-error *ngIf="memberVOmaNum.errors?.['invalid']">Medicaid ID Number is
                                invalid</mat-error>
                              <mat-error *ngIf="memberVOmaNum.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-3"></div>
                        </div>
                        <br *ngIf="
                            isMemberMedicaid == 'Yes' && memberObj1.gencd == 'F'
                          " />
                        <div *ngIf="
                            isMemberMedicaid == 'Yes' && memberObj1.gencd == 'F'
                          " class="row">
                          <div class="col">
                            <mat-label>Is this person pregnant?
                              <span class="text-danger">*</span></mat-label>

                            <mat-radio-group #group color="primary" aria-label="Select an option"
                              [(ngModel)]="pregnantMember" name="pregnantMember" #pregnantMem="ngModel"
                              (click)="isPregnantMember()" [required]="pregnantMemberRequired">
                              <mat-radio-button value="Yes" [required]="pregnantMemberRequired">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No" [required]="pregnantMemberRequired">
                                No
                              </mat-radio-button>
                            </mat-radio-group>
                          </div>
                          <mat-error *ngIf="pregnantMem.errors?.['required'] && customerForm.submitted">Your response is
                            required</mat-error>

                          <div class="col">
                            <div *ngIf="pregnantMember == 'Yes'">
                              <mat-form-field appearance="outline">
                                <mat-label>Due Date<ng-container *ngIf="!dueDateRequired">*</ng-container></mat-label>
                                <input matInput [min]="today" [max]="plus1year" [matDatepicker]="picker2" name="d2"
                                  #c2="ngModel" [(ngModel)]="memberVODuedate" [required]="dueDateRequired" minlength="8"
                                  maxlength="10" (input)="datemask2($event, c2)" (blur)="parseDate($event, c2)"
                                  placeholder="MMDDYYYY" (keypress)="onlyNumeric($event, c2)" />

                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                                <mat-error *ngIf="c2.errors?.['required'] && !c2.errors?.['nomatch']">Due Date is
                                  required</mat-error>
                                <mat-error *ngIf="c2.errors?.['invalid']">Due Date is invalid</mat-error>
                                <mat-error *ngIf="c2.errors?.['matDatepickerMin']">Due Date out of range</mat-error>
                                <mat-error *ngIf="c2.errors?.['matDatepickerMax']">Due Date out of range</mat-error>
                                <mat-error *ngIf="c2.errors?.['nomatch']">Only numerical values are allowed</mat-error>
                                <mat-error *ngIf="c2.errors?.['invalidDate']">Due Date is invalid</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <br />
                    <mat-card>
                      <mat-card-header>
                        <mat-card-subtitle><label><strong> Contact Information </strong>
                          </label></mat-card-subtitle>
                      </mat-card-header>
                      <br />
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Primary Phone</mat-label>
                              <input matInput type="text" name="caseVO.phone1Num"
                                [(ngModel)]="formLa.referralCase.phone1Num" (input)="
                                  formLa.referralCase.phone1Num = phonemask2(
                                    $event,
                                    caseVOphone1Num
                                  )
                                " (blur)="phoneCheck($event, caseVOphone1Num)" maxlength="12"
                                pattern="^\d{3}-\d{3}-\d{4}$" (keypress)="isNumeric($event, caseVOphone1Num)"
                                #caseVOphone1Num="ngModel" />
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['required'] && !caseVOphone1Num.errors?.['nomatch']">Phone
                                Number is required</mat-error>
                              <mat-error *ngIf="caseVOphone1Num.errors?.['invalid']">Phone Number is invalid</mat-error>
                              <mat-error *ngIf="caseVOphone1Num.errors?.['pattern']">Phone Number is invalid</mat-error>
                              <mat-error *ngIf="caseVOphone1Num.errors?.['minlength']">Phone Number is
                                invalid</mat-error>
                              <mat-error *ngIf="caseVOphone1Num.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Secondary Phone</mat-label>
                              <input matInput type="text" name="caseVO.phone2Num"
                                [(ngModel)]="formLa.referralCase.phone2Num" (input)="
                                  formLa.referralCase.phone2Num = phonemask2(
                                    $event,
                                    caseVOphone2Num
                                  )
                                " (blur)="phoneCheck($event, caseVOphone2Num)" maxlength="12"
                                pattern="^\d{3}-\d{3}-\d{4}$" (keypress)="isNumeric($event, caseVOphone2Num)"
                                #caseVOphone2Num="ngModel" />
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['required'] && !caseVOphone2Num.errors?.['nomatch']">Phone
                                Number is required</mat-error>
                              <mat-error *ngIf="caseVOphone2Num.errors?.['invalid']">Phone Number is invalid</mat-error>
                              <mat-error *ngIf="caseVOphone2Num.errors?.['pattern']">Phone Number is invalid</mat-error>
                              <mat-error *ngIf="caseVOphone2Num.errors?.['minlength']">Phone Number is
                                invalid</mat-error>
                              <mat-error *ngIf="caseVOphone2Num.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- <div class="row"> -->
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Email Address</mat-label>
                            <input matInput type="text" name="caseVO.emailTxt"
                              [(ngModel)]="formLa.referralCase.emailTxt"
                              (blur)="formLa.referralCase.emailTxt = formLa.referralCase.emailTxt.trim()"
                              pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,4}$" maxlength="60" uppercase
                              #caseVOemailTxt="ngModel" email />
                            <mat-error *ngIf="caseVOemailTxt.errors?.['required']">Email Address is required</mat-error>
                            <mat-error *ngIf="caseVOemailTxt.errors?.['invalid']">Email Address is invalid</mat-error>
                            <mat-error
                              *ngIf="caseVOemailTxt.errors?.['email'] && !caseVOemailTxt.errors?.['pattern']">Email
                              Address is invalid</mat-error>
                            <mat-error *ngIf="caseVOemailTxt.errors?.['pattern']">Email Address format should
                              be name&#64;example.com</mat-error>
                          </mat-form-field>
                        </div>
                        <!-- </div> -->
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <div class="row">
                      <div class="col">
                        <mat-label>Are you homeless?
                          <span class="text-danger">*</span></mat-label>

                        <mat-radio-group #group color="primary" aria-label="Select an option" [(ngModel)]="homeLess"
                          [required]="homelessRequired" #homeless="ngModel" name="homeLess" (click)="isHomeless()">
                          <mat-radio-button value="Yes" [required]="homelessRequired">
                            Yes
                          </mat-radio-button>
                          <mat-radio-button value="No" [required]="homelessRequired">
                            No
                          </mat-radio-button>
                        </mat-radio-group>

                        <span class="ms-5">If <strong>YES</strong>, you are only required to
                          select the parish where you spend most of your
                          time.</span>
                      </div>
                      <mat-error *ngIf="homeless.errors?.['required'] && customerForm.submitted">Your response is
                        required</mat-error>
                    </div>
                    <br />

                    <!-- <mat-card *ngIf="homeLess == 'Yes'">
                      <mat-card-content> -->
                    <div *ngIf="homeLess == 'Yes'" class="row">
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label>Parish
                            <ng-container *ngIf="!homelessCountyRequired">*</ng-container>
                          </mat-label>
                          <select matNativeControl name="homelessCounty" [(ngModel)]="homelessCounty"
                            #homelessCountyCD="ngModel" [required]="homelessCountyRequired">
                            <ng-container *ngIf="preference.dropDownValues != null">
                              <option *ngFor="
                                  let g of preference.dropDownValues['COUNTYCD']
                                    | keyvalue : originalOrder
                                " [value]="g.key">
                                {{ g.value }}
                              </option>
                            </ng-container>
                          </select>
                          <mat-error *ngIf="homelessCountyCD.errors?.['required']">Parish is required</mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col"></div>
                    </div>
                    <!-- </mat-card-content>
                    </mat-card> -->
                    <mat-card *ngIf="homeLess == 'No'">
                      <mat-card-header>
                        <mat-card-subtitle><mat-label><strong>Residential Address
                              <span class="text-danger">*</span></strong></mat-label></mat-card-subtitle>
                      </mat-card-header>
                      <br />
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Residential Address<ng-container
                                  *ngIf="!resAddress1Required">*</ng-container></mat-label>
                              <input matInput #residentialAddress type="text" name="caseVO.addressLine1Txt"
                                autocomplete="off" #trigger="matAutocompleteTrigger" placeholder="Enter your address"
                                [formControl]="resAddressFormControl.controls.addressLine1"
                                (blur)="validateAddress(resAddressFormControl.controls.addressLine1, resAddressFormControl.controls.cityTxt, resAddressFormControl.controls.stateCd, resAddressFormControl.controls.zipCd)"
                                [required]="resAddress1Required"
                                (keyup)="setDefaultBlank($event,residentialAddress.name, resAddressFormControl,'resAddress')"
                                uppercase maxlength="50" [matAutocomplete]="auto" />
                              <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
                                (optionSelected)="selectSuggestion(resAddressFormControl, residentialAddress.name, resAddressFormControl.controls.addressLine1, $event, trigger, 'resAddress')">
                                <mat-option *ngFor="let suggestion of addressSuggestions.resAddress"
                                  [value]="suggestion">
                                  {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{
                                  suggestion.state }} {{ suggestion.zipcode }}
                                  <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}}
                                    addresses ></span>
                                </mat-option>
                              </mat-autocomplete>
                              <mat-error
                                *ngIf="resAddressFormControl.controls.addressLine1.errors?.['required']">Address is
                                required</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine1.errors?.['invalid']">Enter
                                valid Address</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine1.errors?.['po']">PO box is
                                not allowed in residential address</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine1.errors?.['nomatch']">Only
                                AlphaNumeric and space are
                                allowed</mat-error>

                            </mat-form-field>
                          </div>
                          <div class="col" *ngIf="showResAddress">
                            <mat-form-field appearance="outline">
                              <mat-label>Apartment/Lot</mat-label>
                              <input matInput type="text" name="caseVO.addressLine2Txt"
                                [formControl]="resAddressFormControl.controls.addressLine2" uppercase maxlength="50"
                                readonly />
                              <mat-error
                                *ngIf="resAddressFormControl.controls.addressLine2.errors?.['required']">Address2 is
                                required</mat-error>
                              <mat-error
                                *ngIf="resAddressFormControl.controls.addressLine2.errors?.['invalid']">Address2 is
                                invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine2.errors?.['nomatch']">Only
                                Alphabetical, Space, Hyphen, and Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col" *ngIf="showResAddress">
                            <mat-form-field appearance="outline" class="disableformfiled">
                              <mat-label class="disableLableColor">Parish</mat-label>
                              <!-- <input matInput type="text" name="resparish" [(ngModel)]="resAddress.countyCd"
                                #resParishCD="ngModel" uppercase maxlength="50"
                                readonly /> -->

                              <select matNativeControl style="color: rgba(0, 0, 0, 0.87);" name="resparish"
                                [formControl]="resAddressFormControl.controls.countyCd">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                          let g of preference.dropDownValues['COUNTY']
                            | keyvalue : originalOrder
                        " [value]="g.key">
                                    {{ g.value }}
                                  </option>
                                </ng-container>
                              </select>
                            </mat-form-field>
                          </div>
                        </div>
                        <br *ngIf="homeLess == 'No' && showResAddress" />
                        <div *ngIf="homeLess == 'No' && showResAddress" class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>City<ng-container *ngIf="!resCityRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="caseVO.cityTxt"
                                [formControl]="resAddressFormControl.controls.cityTxt" [required]="resCityRequired"
                                uppercase maxlength="50" readonly />
                              <mat-error *ngIf="resAddressFormControl.controls.cityTxt.errors?.['required']">City is
                                required</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.cityTxt.errors?.['invalid']">City is
                                invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.cityTxt.errors?.['pattern']">City is
                                invalid</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline" class="disableformfiled">
                              <mat-label class="disableLableColor">State<ng-container
                                  *ngIf="!resStateRequired">*</ng-container></mat-label>
                              <select matNativeControl style="color: rgba(0, 0, 0, 0.87);" name="caseVO.stacdRf"
                                [required]="resStateRequired" aria-label="Default select example"
                                [formControl]="resAddressFormControl.controls.stateCd">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                          let state of preference.dropDownValues['STATE']
                            | keyvalue : originalOrder
                        " [value]="state.key">
                                    {{ state.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error *ngIf="resAddressFormControl.controls.stateCd.errors?.['required']">State is
                                required</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Zip Code<ng-container *ngIf="!resZipRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="caseVO.zip5Cd" maxlength="10" minlength="5"
                                [formControl]="resAddressFormControl.controls.zipCd" readonly
                                pattern="(^\d{5}$)|(^\d{5}-\d{4}$)" [required]="resZipRequired" />
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['required']">Zip Code is
                                required</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['invalid']">Zip Code is
                                invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['pattern']">Zip Code is
                                invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['nomatch']">Only numerical
                                values are
                                allowed</mat-error>

                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <div *ngIf="homeLess == 'No'" class="row">
                      <div class="col">
                        <mat-label>Is Residential and mailing address the same?
                          <span class="text-danger">*</span></mat-label>
                        <mat-radio-group #group color="primary" aria-label="Select an option"
                          [(ngModel)]="isSameMailingAddress" [required]="isSameRequired" name="isSameMailingAddress"
                          #isSameMailing="ngModel" (click)="sameMailingAddress()">
                          <mat-radio-button value="Yes" [required]="isSameRequired">
                            Yes
                          </mat-radio-button>
                          <mat-radio-button value="No" [required]="isSameRequired">
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <mat-error *ngIf="isSameMailing.errors?.['required'] && customerForm.submitted">Your response is
                        required</mat-error>
                    </div>
                    <br *ngIf="homeLess == 'No'" />
                    <mat-card *ngIf="homeLess == 'No' && isSameMailingAddress == 'No'">
                      <mat-card-header>
                        <mat-card-subtitle><mat-label><strong>Mailing Address
                              <span class="text-danger">*</span></strong></mat-label></mat-card-subtitle>
                      </mat-card-header>
                      <br />
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Mailing Address<ng-container
                                  *ngIf="!mailAddress1Required">*</ng-container></mat-label>
                              <input matInput #mailingAddress type="text" name="mailAddress.addressLine1Txt"
                                autocomplete="off" #trigger1="matAutocompleteTrigger"
                                (keyup)="setDefaultBlank($event,mailingAddress.name, mailAddressFormControl, 'mailAddress')"
                                placeholder="Enter your address"
                                 (blur)="validateAddress(mailAddressFormControl.controls.addressLine1, mailAddressFormControl.controls.cityTxt, mailAddressFormControl.controls.stateCd, mailAddressFormControl.controls.zipCd)"
                                [required]="mailAddress1Required"
                                [formControl]="mailAddressFormControl.controls.addressLine1" uppercase maxlength="50"
                                [matAutocomplete]="auto" />

                              <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
                                (optionSelected)="selectSuggestion(mailAddressFormControl, mailingAddress.name, mailAddressFormControl.controls.addressLine1, $event, trigger1, 'mailAddress')">
                                <mat-option *ngFor="let suggestion of addressSuggestions.mailAddress"
                                  [value]="suggestion">
                                  {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{
                                  suggestion.state }} {{ suggestion.zipcode }}
                                  <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}}
                                    addresses ></span>
                                </mat-option>
                              </mat-autocomplete>
                              <mat-error
                                *ngIf="mailAddressFormControl.controls.addressLine1.errors?.['required']">Address is
                                required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.addressLine1.errors?.['invalid']">Enter
                                valid Address</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.addressLine1.errors?.['nomatch']">Only
                                AlphaNumeric and space are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col" *ngIf="showMailAddress">
                            <mat-form-field appearance="outline">
                              <mat-label>Apartment/Lot</mat-label>
                              <input matInput type="text" name="mailAddress.addressLine2Txt"
                                [formControl]="mailAddressFormControl.controls.addressLine2" uppercase maxlength="50"
                                readonly />
                              <mat-error
                                *ngIf="mailAddressFormControl.controls.addressLine2.errors?.['required']">Address2 is
                                required</mat-error>
                              <mat-error
                                *ngIf="mailAddressFormControl.controls.addressLine2.errors?.['invalid']">Address2 is
                                invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.addressLine2.errors?.['nomatch']">Only
                                Alphabetical, Space, Hyphen, and Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div *ngIf="
                            homeLess == 'No' &&
                            isSameMailingAddress == 'No' &&
                            showMailAddress
                          " class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>City<ng-container *ngIf="!mailCityRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="mailAddress.cityTxt"
                                [formControl]="mailAddressFormControl.controls.cityTxt" [required]="mailCityRequired"
                                uppercase maxlength="50" readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['required']">City is
                                required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['invalid']">City is
                                invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['pattern']">City is
                                invalid</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline" class="disableformfiled">
                              <mat-label class="disableLableColor">State<ng-container
                                  *ngIf="!mailStateRequired">*</ng-container></mat-label>
                              <select matNativeControl style="color: rgba(0, 0, 0, 0.87);" name="mailAddress.stacdRf"
                                [required]="mailStateRequired" aria-label="Default select example"
                                [formControl]="mailAddressFormControl.controls.stateCd">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                          let state of preference.dropDownValues['STATE']
                            | keyvalue : originalOrder
                        " [value]="state.key">
                                    {{ state.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error *ngIf="mailAddressFormControl.controls.stateCd.errors?.['required']">State is
                                required</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Zip Code<ng-container *ngIf="!mailZipRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="mailing.zip5Cd" maxlength="10" minlength="5"
                                [formControl]="mailAddressFormControl.controls.zipCd"
                                pattern="(^\d{5}$)|(^\d{5}-\d{4}$)" [required]="mailZipRequired" readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['required']">Zip Code is
                                required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['invalid']">Zip Code is
                                invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['pattern']">Zip Code is
                                invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['nomatch']">Only
                                numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                    <br />
                  </div>
                  <div *ngIf="existingMember != null" class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button mat-raised-button color="primary" matStepperNext (click)="farword()"
                      [disabled]="existingMember == null">
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step label="Employer/Policy" aria-label="Employer/Policy" [completed]="employerPolicyCheck()">
                <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
                  <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
                    Apply Now
                  </legend>

                  <div class="row">
                    <div class="col"></div>
                  </div>
                  <mat-card class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle><label><strong>
                            Tell us about the employer or insurance company that
                            offers health insurance or COBRA coverage.
                          </strong>
                        </label></mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-label>Is this health insurance through?<span class="text-danger">*</span></mat-label>
                          <mat-radio-group #group color="primary" aria-label="Select an option"
                            [(ngModel)]="formLa.referralPolicy.sourceCd" #sourceCd="ngModel" name="isHealthInsurance"
                            [required]="sourceCdRequired">
                            <mat-radio-button value="E" [required]="sourceCdRequired">
                              Employer
                            </mat-radio-button>
                            <mat-radio-button value="C" [required]="sourceCdRequired">
                              COBRA
                            </mat-radio-button>
                            <mat-radio-button value="S" [required]="sourceCdRequired">
                              Self-Insured
                            </mat-radio-button>
                            <mat-radio-button value="M" [required]="sourceCdRequired">
                              Marketplace
                            </mat-radio-button>
                          </mat-radio-group>
                          <mat-error *ngIf="sourceCd.errors?.['required'] && customerForm.submitted">Your response is
                            required</mat-error>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Employer or Company Name<ng-container *ngIf="
                                  existingMember == 'No' && !eplyrNmRequired
                                ">*</ng-container></mat-label>
                            <input matInput type="text" name="employerVO.emplyrNm"
                              [(ngModel)]="formLa.referralEmployer.emplyrNm" maxlength="100" uppercase
                              pattern="^(?![ -\/]).+" [required]="eplyrNmRequired"
                              (keypress)="allowAlphaNumericWithSplChar($event)" #emplyrNm="ngModel" />
                            <mat-error *ngIf="emplyrNm.errors?.['required']">Employer Name is required</mat-error>
                            <mat-error *ngIf="emplyrNm.errors?.['pattern']">Employer Name is invalid</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Phone Number<ng-container *ngIf="
                                  existingMember == 'No' && !emplyrPhoneRequired
                                ">*</ng-container></mat-label>
                            <input matInput type="text" name="employerVO.phone1Num"
                              [(ngModel)]="formLa.referralEmployer.phone1Num" maxlength="12"
                              pattern="^\d{3}-\d{3}-\d{4}$" [required]="emplyrPhoneRequired" (input)="
                                formLa.referralEmployer.phone1Num = phonemask2(
                                  $event,
                                  employerphone1Num
                                )
                              " (blur)="phoneCheck($event, employerphone1Num)"
                              (keypress)="isNumeric($event, employerphone1Num)" #employerphone1Num="ngModel" />
                            <mat-error *ngIf="employerphone1Num.errors?.['invalid']">Phone Number is invalid</mat-error>
                            <mat-error *ngIf="employerphone1Num.errors?.['pattern']">Phone Number is invalid</mat-error>
                            <mat-error *ngIf="employerphone1Num.errors?.['minlength']">Phone Number is
                              invalid</mat-error>
                            <mat-error
                              *ngIf="employerphone1Num.errors?.['required'] && !employerphone1Num.errors?.['nomatch']">Phone
                              Number is required</mat-error>
                            <mat-error *ngIf="employerphone1Num.errors?.['nomatch']">Only numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Address<ng-container
                                *ngIf="existingMember =='No' && !emplyrAddr1Required">*</ng-container></mat-label>
                            <input matInput type="text" #emplyrAddress name="employerVO.addressLine1Txt"
                              autocomplete="off" #trigger2="matAutocompleteTrigger"
                              (blur)="validateAddress(referralEmployerAddressFormControl.controls.address1Txt, referralEmployerAddressFormControl.controls.cityTxt, referralEmployerAddressFormControl.controls.stateCd, referralEmployerAddressFormControl.controls.zipCd)"
                              (keyup)="setDefaultBlank($event, emplyrAddress.name, referralEmployerAddressFormControl, 'referralEmployerAddress')"
                              placeholder="Enter your address" [required]="emplyrAddr1Required"
                              [formControl]="referralEmployerAddressFormControl.controls.address1Txt" uppercase
                              maxlength="50" [matAutocomplete]="auto2" />
                            <mat-autocomplete #auto2="matAutocomplete" autoActiveFirstOption
                              (optionSelected)="selectSuggestion(referralEmployerAddressFormControl, emplyrAddress.name, referralEmployerAddressFormControl.controls.address1Txt, $event, trigger2, 'referralEmployerAddress')">
                              <mat-option *ngFor="let suggestion of addressSuggestions.referralEmployerAddress"
                                [value]="suggestion">
                                {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{
                                suggestion.state }} {{ suggestion.zipcode }}
                                <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}}
                                  addresses ></span>
                              </mat-option>
                            </mat-autocomplete>
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.address1Txt.errors?.['required']">Employer
                              Address is required</mat-error>
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.address1Txt.errors?.['invalid']">Enter
                              valid Address</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col" *ngIf="showEmployerAddress">
                          <mat-form-field appearance="outline">
                            <mat-label>Suite/Unit</mat-label>
                            <input matInput type="text" name="employerVO.addressLine2Txt"
                              [formControl]="referralEmployerAddressFormControl.controls.address2Txt" uppercase
                              maxlength="40" readonly />
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.address2Txt.errors?.['required']">Employer
                              Suite/Unit is
                              required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br *ngIf="showEmployerAddress" />
                      <div class="row" *ngIf="showEmployerAddress">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>City<ng-container
                                *ngIf="existingMember =='No' && !emplyrCityRequired">*</ng-container></mat-label>
                            <input matInput type="text" name="employerVO.cityTxt" [required]="emplyrCityRequired"
                              [formControl]="referralEmployerAddressFormControl.controls.cityTxt" uppercase
                              maxlength="20" readonly />
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.cityTxt.errors?.['invalid']">City is
                              invalid</mat-error>
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.cityTxt.errors?.['pattern']">City is
                              invalid</mat-error>
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.cityTxt.errors?.['required']">City is
                              required</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline" class="disableformfiled">
                            <mat-label class="disableLableColor">State<ng-container
                                *ngIf="existingMember =='No' && !emplyrStateRequired">*</ng-container></mat-label>
                            <select matNativeControl style="color: rgba(0, 0, 0, 0.87);" name="employerVO.stacdRf"
                              [formControl]="referralEmployerAddressFormControl.controls.stateCd"
                              aria-label="Default select example" [required]="emplyrStateRequired">
                              <ng-container *ngIf="preference.dropDownValues != null">
                                <option *ngFor="
                          let state of preference.dropDownValues['STATE']
                            | keyvalue : originalOrder
                        " [value]="state.key">
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.stateCd.errors?.['required']">State is
                              required</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Zip Code<ng-container
                                *ngIf="existingMember =='No' && !emplyrZipCodeRequired">*</ng-container></mat-label>
                            <input matInput type="text" name="employerVO.zip5Cd"
                              [formControl]="referralEmployerAddressFormControl.controls.zipCd" minlength="5"
                              maxlength="10" [required]="emplyrZipCodeRequired" pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                              readonly />
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['invalid']">Zip
                              Code is invalid</mat-error>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['pattern']">Zip
                              Code is invalid</mat-error>
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['required']">Zip Code is
                              required</mat-error>
                            <mat-error
                              *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['nomatch']">Only
                              numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Employer FEIN (Tax ID)<ng-container *ngIf="
                                  existingMember == 'No' && !emplyrFeinRequired
                                ">*</ng-container></mat-label>
                            <input matInput type="text" name="employerVO.emplyrFein"
                              [(ngModel)]="formLa.referralEmployer.emplyrFein" minlength="10" maxlength="10"
                              (keypress)="isNumeric($event, empFEINValue)" (input)="
                                formLa.referralEmployer.emplyrFein =
                                  empFEINMask($event, empFEINValue)
                              " pattern="(^\d{2}-\d{7}$)" #empFEINValue="ngModel" [required]="emplyrFeinRequired"
                              (blur)="isFEINValidValue($event, empFEINValue)" />
                            <mat-error *ngIf="empFEINValue.errors?.['invalid']">Employer FEIN is invalid</mat-error>
                            <mat-error *ngIf="empFEINValue.errors?.['pattern']">Employer FEIN is invalid</mat-error>
                            <mat-error
                              *ngIf="empFEINValue.errors?.['required'] && !empFEINValue.errors?.['nomatch']">Employer
                              FEIN is required</mat-error>
                            <mat-error *ngIf="empFEINValue.errors?.['nomatch']">Only numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                  <br />
                  <mat-card class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle><label><strong>
                            Tell us about the health insurance or COBRA plan
                            that the Policyholder is currently enrolled in or
                            has access to.
                          </strong>
                        </label>
                      </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Company Name</mat-label>
                            <input matInput type="text" name="policyVO.carrierNm"
                              [(ngModel)]="formLa.referralPolicy.carrierNm" uppercase maxlength="40"
                              (blur)="validateCarrierNm($event,policyVOcarrierNm)"
                              (keypress)="allowAlphaNumericForCarrier($event,policyVOcarrierNm)"
                              #policyVOcarrierNm="ngModel" />
                            <mat-error *ngIf="policyVOcarrierNm.errors?.['required']">Company name is
                              required</mat-error>
                            <mat-error *ngIf="policyVOcarrierNm.errors?.['nomatch']">This field only allows - ( ) /
                              space, alphanumeric characters and cannot end with a special character or
                              space</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Contact Number</mat-label>
                            <input matInput type="text" name="policyVO.phone1Num"
                              [(ngModel)]="formLa.referralPolicy.phone1Num" maxlength="12" pattern="^\d{3}-\d{3}-\d{4}$"
                              (input)="
                                formLa.referralPolicy.phone1Num = phonemask2(
                                  $event,
                                  policyVoPhoneNum
                                )
                              " (blur)="phoneCheck($event, policyVoPhoneNum)"
                              (keypress)="isNumeric($event, policyVoPhoneNum)" #policyVoPhoneNum="ngModel" />
                            <mat-error *ngIf="policyVoPhoneNum.errors?.['invalid']">Contact Number is
                              invalid</mat-error>
                            <mat-error *ngIf="policyVoPhoneNum.errors?.['pattern']">Contact Number is
                              invalid</mat-error>
                            <mat-error *ngIf="policyVoPhoneNum.errors?.['minlength']">Contact Number is
                              invalid</mat-error>
                            <mat-error *ngIf="policyVoPhoneNum.errors?.['nomatch']">Only numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Company Address</mat-label>
                            <input matInput type="text" #policyAddress name="policyVO.addressLine1Txt"
                              autocomplete="off"
                              (blur)="validateAddress(referralPolicyAddressFormControl.controls.address1Txt, referralPolicyAddressFormControl.controls.cityTxt, referralPolicyAddressFormControl.controls.stateCd, referralPolicyAddressFormControl.controls.zipCd)"
                              (keyup)="setDefaultBlank($event, policyAddress.name, referralPolicyAddressFormControl,'referralPolicyAddress')"
                              placeholder="Enter your address" #trigger3="matAutocompleteTrigger"
                              [formControl]="referralPolicyAddressFormControl.controls.address1Txt" uppercase
                              maxlength="50" [matAutocomplete]="auto1" />

                            <mat-autocomplete #auto1="matAutocomplete" autoActiveFirstOption
                              (optionSelected)="selectSuggestion(referralPolicyAddressFormControl, policyAddress.name, referralPolicyAddressFormControl.controls.address1Txt, $event, trigger3,'referralPolicyAddress')">
                              <mat-option *ngFor="let suggestion of addressSuggestions.referralPolicyAddress"
                                [value]="suggestion">
                                {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{
                                suggestion.state }} {{ suggestion.zipcode }}
                                <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}}
                                  addresses ></span>
                              </mat-option>
                            </mat-autocomplete>
                            <mat-error
                              *ngIf="referralPolicyAddressFormControl.controls.address1Txt.errors?.['required']">Address
                              is required</mat-error>
                            <mat-error
                              *ngIf="referralPolicyAddressFormControl.controls.address1Txt.errors?.['invalid']">Enter
                              valid Address</mat-error>
                            <mat-error
                              *ngIf="referralPolicyAddressFormControl.controls.address1Txt.errors?.['nomatch']">Only
                              AlphaNumeric and space are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col" *ngIf="showPolicyAddress">
                          <mat-form-field appearance="outline">
                            <mat-label>Suite/Unit</mat-label>
                            <input matInput type="text" name="policyVO.addressLine2Txt"
                              [formControl]="referralPolicyAddressFormControl.controls.address2Txt" uppercase
                              maxlength="40" readonly />
                          </mat-form-field>
                        </div>
                      </div>
                      <br *ngIf="showPolicyAddress" />

                      <div class="row" *ngIf="showPolicyAddress">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>City</mat-label>
                            <input matInput type="text" name="policyVO.cityTxt"
                              [formControl]="referralPolicyAddressFormControl.controls.cityTxt" uppercase maxlength="40"
                              readonly />
                            <mat-error
                              *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['invalid']">City is
                              invalid</mat-error>
                            <mat-error
                              *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['pattern']">City is
                              invalid</mat-error>
                            <mat-error
                              *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['required']">City is
                              required</mat-error>
                            <mat-error
                              *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['nomatch']">Only
                              Alphabetical, Space, Hyphen, and Apostrophe are allowed.</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline" class="disableformfiled">
                            <mat-label class="disableLableColor">State</mat-label>
                            <select matNativeControl style="color: rgba(0, 0, 0, 0.87);" name="policyVO.stacdRf"
                              [formControl]="referralPolicyAddressFormControl.controls.stateCd"
                              aria-label="Default select example" [required]="policyStateRequired">
                              <ng-container *ngIf="preference.dropDownValues != null">
                                <option *ngFor="
                          let state of preference.dropDownValues['STATE']
                            | keyvalue : originalOrder
                        " [value]="state.key">
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Zip Code</mat-label>
                            <input matInput type="text" name="policyVO.zip5Cd"
                              [formControl]="referralPolicyAddressFormControl.controls.zipCd" minlength="5"
                              maxlength="10" pattern="(^\d{5}$)|(^\d{5}-\d{4}$)" readonly />
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.zipCd.errors?.['invalid']">Zip
                              Code is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.zipCd.errors?.['pattern']">Zip
                              Code is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.zipCd.errors?.['nomatch']">Only
                              numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Plan Name</mat-label>
                            <input matInput type="text" name="policyVO.planName"
                              [(ngModel)]="formLa.referralPolicy.planName" maxlength="100" uppercase
                              (keypress)="allowAlphaNumericWithSplChars($event,policyPlanNm)"
                              (blur)="validatePlanNm($event,policyPlanNm)" #policyPlanNm="ngModel" />
                            <mat-error *ngIf="policyPlanNm.errors?.['nomatch']">This field only allows - / # & space,
                              alphanumeric characters and cannot end with a special character or space</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Policy ID Number</mat-label>
                            <input matInput type="text" name="policyVO.policyNum"
                              [(ngModel)]="formLa.referralPolicy.policyNum" uppercase maxlength="20" #policyId="ngModel"
                              (keypress)="allowAlphaNumericWithoutSpace($event,policyId)"
                              (blur)="validatePolicyId($event,policyId)" />
                            <mat-error *ngIf="policyId.errors?.['nomatch']">This field only allows alphanumeric
                              characters</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Group Number</mat-label>
                            <input matInput type="text" name="policyVO.groupNum"
                              [(ngModel)]="formLa.referralPolicy.groupNum" uppercase maxlength="15"
                              (blur)="validateGroupNum($event,policyGroupNum)" #policyGroupNum="ngModel"
                              (keypress)="allowAlphaNumericWithTwoSplChar($event,policyGroupNum)" />
                            <mat-error *ngIf="policyGroupNum.errors?.['nomatch']">This field only allows alphanumeric
                              characters, space, - and cannot end with a special character or space</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Policy Start Date</mat-label>
                            <input matInput [matDatepicker]="picker3" [min]="prev10year" [max]="next5year" name="d3"
                              #c3="ngModel" [(ngModel)]="policyVOpolicyStartDate" minlength="8" maxlength="10"
                              placeholder="MMDDYYYY" (input)="datemask2($event, c3)" (blur)="parseDate($event, c3)"
                              (keypress)="onlyNumeric($event, c3)" />

                            <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                            <mat-error *ngIf="c3.errors?.['minlength']">Policy start date is invalid</mat-error>
                            <mat-error *ngIf="c3.errors?.['invalid']">Policy start date is invalid</mat-error>
                            <mat-error *ngIf="c3.errors?.['matDatepickerMin']">Policy start date out of
                              range</mat-error>
                            <mat-error *ngIf="c3.errors?.['matDatepickerMax']">Policy start date out of
                              range</mat-error>
                            <mat-error *ngIf="c3.errors?.['nomatch']">Only numerical values are allowed</mat-error>
                            <mat-error *ngIf="c3.errors?.['invalidDate']">Policy start date is invalid</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Plan Tier<ng-container *ngIf="
                                  existingMember == 'Yes' && !planTierRequired
                                ">*</ng-container></mat-label>
                            <select matNativeControl name="policyVO.planTier"
                              [(ngModel)]="formLa.referralPolicy.planTier" aria-label="Default select example"
                              [required]="planTierRequired" #planTier="ngModel">
                              <ng-container *ngIf="preference.dropDownValues != null">
                                <option *ngFor="
                                    let state of preference.dropDownValues[
                                      'TIER'
                                    ] | keyvalue : originalOrder
                                  " [value]="state.key">
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="planTier.errors?.['required']">Plan Tier is required</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Deductible For Selected Plan<ng-container *ngIf="
                                  existingMember == 'Yes' && !deductibleRequired
                                ">*</ng-container></mat-label>
                            <input matInput type="text" name="Deductible"
                              [(ngModel)]="formLa.referralPolicy.planDeductible" #Deductible="ngModel" maxlength="8"
                              min="0" pattern="^[0-9]{1,7}(\.[0-9]{0,2})?$" (input)="
                                formLa.referralPolicy.planDeductible =
                                  amountMask($event, Deductible)
                              " (blur)="validateAmount($event, Deductible)" [required]="deductibleRequired" />
                            <span matTextPrefix>$&nbsp;</span>
                            <mat-error *ngIf="Deductible.errors?.['required']">Deductible is required</mat-error>
                            <mat-error *ngIf="Deductible.errors?.['invalid']">Deductible is invalid</mat-error>
                            <mat-error *ngIf="Deductible.errors?.['nomatch']">Deductible is invalid</mat-error>
                            <mat-error *ngIf="Deductible.errors?.['pattern']">Deductible is invalid</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>How frequent is the premium
                              paid/deducted?<ng-container *ngIf="
                                  existingMember == 'Yes' && !frequencyRequired
                                ">*</ng-container>
                            </mat-label>
                            <select matNativeControl name="policyVO.frequency"
                              [(ngModel)]="formLa.referralPolicy.frequency" #frequency="ngModel"
                              aria-label="Default select example" [required]="frequencyRequired">
                              <ng-container *ngIf="preference.dropDownValues != null">
                                <option *ngFor="
                                    let state of preference.dropDownValues[
                                      'FREQUENCY'
                                    ] | keyvalue : originalOrder
                                  " [value]="state.key">
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="frequency.errors?.['required']">Frequency is required</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Premium Amount<ng-container *ngIf="
                                  existingMember == 'Yes' &&
                                  !premiumAmountRequired
                                ">*</ng-container></mat-label>

                            <!-- <mat-label>Premium Amount<ng-container
                              *ngIf="premiumAmountRequired">*</ng-container></mat-label> -->
                            <input matInput type="text" name="premium" [(ngModel)]="
                                formLa.referralPolicy.employeePremium
                              " #policyVOempyPremium="ngModel" maxlength="8" min="0"
                              pattern="^[0-9]{1,7}(\.[0-9]{0,2})?$" (input)="
                                formLa.referralPolicy.employeePremium =
                                  amountMask($event, policyVOempyPremium)
                              " (blur)="
                                validateAmount($event, policyVOempyPremium)
                              " [required]="premiumAmountRequired" />
                            <span matTextPrefix>$&nbsp;</span>
                            <mat-error *ngIf="policyVOempyPremium.errors?.['required']">Premium Amount is
                              required</mat-error>
                            <mat-error *ngIf="policyVOempyPremium.errors?.['invalid']">Premium Amount is
                              invalid</mat-error>
                            <mat-error *ngIf="policyVOempyPremium.errors?.['nomatch']">Premium Amount is
                              invalid</mat-error>
                            <mat-error *ngIf="policyVOempyPremium.errors?.['pattern']">Premium Amount is
                              invalid</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                    </mat-card-content>
                  </mat-card>
                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button mat-raised-button matStepperPrevious style="background-color: #b89d18; color: white"
                      (click)="goBack()">
                      Previous
                    </button>
                    <button mat-raised-button color="primary" matStepperNext (click)="goForward()">
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step label="Family Members" aria-label="Family Members" [completed]="familyMemberCheck()">
                <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
                  <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
                    Apply Now
                  </legend>
                  <div class="row">
                    <div class="col">
                      <mat-form-field #field floatLabel="always" appearance="outline">
                        <mat-label class="fw-bold">Are there additional family member(s) who receive
                          Medicaid?
                          <ng-container *ngIf="!isFamilyRequired">*</ng-container>
                        </mat-label>
                        <input matInput name="familyMemberMedicate" [(ngModel)]="isFamilyMemberMedicate"
                          #familyMedicate="ngModel" style="display: none" [required]="isFamilyRequired" />
                        <mat-radio-group #group color="primary" aria-label="Select an option"
                          [(ngModel)]="isFamilyMemberMedicate" [required]="isFamilyRequired" #familyMedicate="ngModel"
                          name="familyMemberMedicate" (change)="removeSavedFamilyMembers($event)">
                          <mat-radio-button value="Yes" [required]="isFamilyRequired">
                            Yes
                          </mat-radio-button>
                          <mat-radio-button value="No" [required]="isFamilyRequired">
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                        <mat-error *ngIf="familyMedicate.errors?.['required'] && customerForm.submitted">Your response
                          is required</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div *ngIf="isFamilyMemberMedicate == 'Yes'">
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle><label><strong> Add Family Members </strong>
                          </label></mat-card-subtitle>
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>First Name<ng-container *ngIf="!otherFnRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="otherfirstNm" [(ngModel)]="otherfirstNm" maxlength="20"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                #otherFN="ngModel" [required]="otherFnRequired" uppercase
                                (keypress)="allowAlphabets2($event, otherFN)" (blur)="nomatchCheck($event, otherFN)" />
                              <mat-error *ngIf="otherFN.errors?.['required']  && !otherFN.errors?.['nomatch']">First
                                Name is required</mat-error>
                              <mat-error *ngIf="otherFN.errors?.['invalid']">First Name is invalid</mat-error>
                              <mat-error *ngIf="otherFN.errors?.['pattern']">First Name is invalid</mat-error>
                              <mat-error *ngIf="otherFN.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>MI</mat-label>
                              <input matInput type="text" name="othermiNm" [(ngModel)]="othermiNm" maxlength="1"
                                #otherMi="ngModel" uppercase (keypress)="
                                  allowOnlyOneAlphabet($event, otherMi)
                                " />
                              <mat-error *ngIf="otherMi.errors?.['invalid']">Middle Name is invalid</mat-error>
                              <mat-error *ngIf="otherMi.errors?.['nomatch']">Only Alphabet is allowed</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Last Name<ng-container *ngIf="!otherLnRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="otherlastNm" [(ngModel)]="otherlastNm" maxlength="20"
                                #otherLN="ngModel" [required]="otherLnRequired"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                uppercase (keypress)="allowAlphabets2($event, otherLN)"
                                (blur)="nomatchCheck($event, otherLN)" />
                              <mat-error *ngIf="otherLN.errors?.['required'] && !otherLN.errors?.['nomatch']">Last Name
                                is required</mat-error>
                              <mat-error *ngIf="otherLN.errors?.['invalid']">Last Name is invalid</mat-error>
                              <mat-error *ngIf="otherLN.errors?.['pattern']">Last Name is invalid</mat-error>
                              <mat-error *ngIf="otherLN.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Suffix</mat-label>
                              <select matNativeControl name="othersuffixNm" [(ngModel)]="othersuffixNm"
                                aria-label="Default select example">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                                      let suffix of preference.dropDownValues[
                                        'SUFFIX'
                                      ] | keyvalue : originalOrder
                                    " [value]="suffix.key">
                                    {{ suffix.value }}
                                  </option>
                                  mi
                                </ng-container>
                              </select>
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Social Security Number<ng-container
                                  *ngIf="!otherSsnRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="otherssnNum" [(ngModel)]="otherssnNum" (input)="
                                  otherssnNum = ssnmask($event, otherSsn)
                                " maxlength="11" (keypress)="isNumeric($event, otherSsn)" #otherSsn="ngModel"
                                (blur)="verifySSN($event, true, otherSsn)" pattern="^\d{3}-\d{2}-\d{4}$"
                                [required]="otherSsnRequired" />
                              <mat-error *ngIf="otherSsn.errors?.['required'] && !otherSsn.errors?.['nomatch']">Social
                                Security Number is required</mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['invalid']">Social Security Number is
                                invalid</mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['invalidSsn']">Social Security Number is
                                invalid</mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['pattern']">
                                <ng-container *ngIf="otherssnNum.length < 11">Social Security Number length is
                                  short</ng-container>
                                <ng-container *ngIf="otherssnNum.length > 10">Social Security Number is
                                  invalid</ng-container>
                              </mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['duplicate']">SSN already used.</mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['recordPresent']">{{ getSSNUsedMessage()
                                }}</mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Date of Birth<ng-container
                                  *ngIf="!otherDobRequired">*</ng-container></mat-label>
                              <input matInput [matDatepicker]="picker4" [min]="prev100year" [max]="today" name="d6"
                                [(ngModel)]="otherdobDate" [required]="otherDobRequired" #otherDob="ngModel"
                                minlength="8" maxlength="10" placeholder="MMDDYYYY"
                                (input)="datemask2($event, otherDob)" (blur)="parseDate($event, otherDob)"
                                (keypress)="onlyNumeric($event, otherDob)" />

                              <mat-datepicker-toggle matIconSuffix [for]="picker4"></mat-datepicker-toggle>
                              <mat-datepicker #picker4></mat-datepicker>
                              <mat-error *ngIf="otherDob.errors?.['required'] && !otherDob.errors?.['nomatch']">Date of
                                Birth is required</mat-error>
                              <mat-error *ngIf="otherDob.errors?.['invalid']">Date of Birth is invalid</mat-error>
                              <mat-error *ngIf="otherDob.errors?.['matDatepickerMin']">Date of Birth is out of
                                range</mat-error>
                              <mat-error *ngIf="otherDob.errors?.['matDatepickerMax']">Date of Birth is out of
                                range</mat-error>
                              <mat-error *ngIf="otherDob.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                              <mat-error *ngIf="otherDob.errors?.['invalidDate']">Date of Birth is invalid</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Sex<ng-container *ngIf="!otherGnRequired">*</ng-container></mat-label>
                              <select matNativeControl name="othergencdRf" [(ngModel)]="othergencdRf"
                                #otherGender="ngModel" aria-label="Default select example" [required]="otherGnRequired"
                                (change)="isGenderOtherChange()">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                                      let g of preference.dropDownValues[
                                        'SEX'
                                      ] | keyvalue : originalOrder
                                    " [value]="g.key">
                                    {{ g.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error *ngIf="otherGender.errors?.['required']">Sex is required</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Relationship to Policyholder<ng-container
                                  *ngIf="!otherRsRequired">*</ng-container></mat-label>
                              <select matNativeControl name="otherrshcdRf" aria-label="Default select example"
                                [(ngModel)]="otherrshcdRf" #otherRelationship="ngModel" [required]="otherRsRequired">
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                                      let r of preference.dropDownValues[
                                        'RELATIONSHIP'
                                      ] | keyvalue : originalOrder
                                    " [value]="r.key">
                                    {{ r.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error *ngIf="otherRelationship.errors?.['required']">Relationship is
                                required</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Medicaid ID<ng-container *ngIf="!otherMaNumRequired">*</ng-container>
                              </mat-label>
                              <input matInput type="text" name="othermaNum" [(ngModel)]="othermaNum" uppercase
                                maxlength="13" pattern="^\d{13}$" [required]="otherMaNumRequired"
                                #otherVOmaNum="ngModel" (keypress)="isNumeric($event, otherVOmaNum)"
                                (blur)="isMedicaidValid($event, otherVOmaNum)" />
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['required'] && !otherVOmaNum.errors?.['nomatch']">Medicaid
                                ID is required</mat-error>
                              <mat-error *ngIf="otherVOmaNum.errors?.['pattern']">Medicaid ID is invalid</mat-error>
                              <mat-error *ngIf="otherVOmaNum.errors?.['invalid']">Medicaid ID is invalid</mat-error>
                              <mat-error *ngIf="otherVOmaNum.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col" *ngIf="othergencdRf == 'F'">
                            <mat-label>Is this person pregnant?
                              <span class="text-danger">*</span></mat-label>

                            <mat-radio-group #group color="primary" aria-label="Select an option"
                              [(ngModel)]="pregnantOther" [required]="pregnantOtherRequired" name="pregnantOther"
                              #pregnantOtherResponse="ngModel" (click)="isPregnantOther()">
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                              <mat-error *ngIf="pregnantOtherResponse.errors?.['required']">Your Response is
                                Required</mat-error>
                            </mat-radio-group>
                          </div>
                          <div class="col" *ngIf="
                              pregnantOther == 'Yes' && othergencdRf == 'F'
                            ">
                            <div>
                              <mat-form-field appearance="outline">
                                <mat-label>Due Date<ng-container
                                    *ngIf="!otherDueDateRequired">*</ng-container></mat-label>
                                <input matInput [matDatepicker]="picker7" name="d7" #c7="ngModel"
                                  [(ngModel)]="otherMemberDueDate" [min]="today" [max]="plus1year" required
                                  minlength="8" maxlength="10" placeholder="MMDDYYYY" (input)="datemask2($event, c7)"
                                  (blur)="parseDate($event, c7)" [required]="otherDueDateRequired"
                                  (keypress)="onlyNumeric($event, c7)" />

                                <mat-datepicker-toggle matIconSuffix [for]="picker7"></mat-datepicker-toggle>
                                <mat-datepicker #picker7></mat-datepicker>
                                <mat-error *ngIf="c7.errors?.['required'] && !c7.errors?.['nomatch']">Due date is
                                  required</mat-error>
                                <mat-error *ngIf="c7.errors?.['invalid']">Due date is invalid</mat-error>
                                <mat-error *ngIf="c7.errors?.['matDatepickerMin']">Due date is out of range</mat-error>
                                <mat-error *ngIf="c7.errors?.['matDatepickerMax']">Due date is out of range</mat-error>
                                <mat-error *ngIf="c7.errors?.['nomatch']">Only numerical values are allowed</mat-error>
                                <mat-error *ngIf="c7  .errors?.['invalidDate']">Due Date is invalid</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col" *ngIf="othergencdRf == 'M' || othergencdRf == ''"></div>
                          <div class="col" *ngIf="pregnantOther == 'No' || pregnantOther == ''"></div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-label>Is this person enrolled in the health insurance
                              plan listed in previous page?
                              <span class="text-danger">*</span>
                            </mat-label>

                            <mat-radio-group #group color="primary" aria-label="Select an option"
                              [(ngModel)]="otherEnrolled" name="otherEnrolled" #enrolledInPolicy="ngModel"
                              [required]="otherEnrolledRequired">
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                              <mat-error *ngIf="enrolledInPolicy.errors?.['required']">Your Response is
                                Required</mat-error>
                            </mat-radio-group>
                          </div>
                          <mat-error *ngIf="addClearFamilyFilled">Do you want to add or clear the filled family
                            member details before clicking on the Next
                            button?</mat-error>
                        </div>
                        <div class="row">
                          <div class="col text-center">
                            <button id="addFamilyMember" mat-raised-button color="primary" type="button" class="m-1"
                              (click)="addFamilyMember($event)">
                              <ng-container *ngIf="editIndex == undefined">Add Family Member</ng-container>
                              <ng-container *ngIf="editIndex != undefined">Save Family Member</ng-container>
                            </button>
                            <button id="clearFamilyMember" mat-raised-button type="button" class="m-1"
                              (click)="clear($event)">
                              Clear Family Member
                            </button>
                          </div>
                        </div>
                        <br />
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <div *ngIf="formLa.referralMemberList.length > 0">
                      <div class="text-center fw-bold">
                        Below are the family members you have already added
                      </div>
                      <br />

                      <table mat-table class="table table-bordered table-hover mat-elevation-z8"
                        style="border: 2px solid #63b1bc">
                        <thead class="table-success">
                          <tr>
                            <th scope="col">First Name</th>
                            <th scope="col">MI</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Suffix</th>
                            <th scope="col">SSN</th>
                            <th scope="col">DOB</th>
                            <th scope="col">Sex</th>
                            <th scope="col">Relationship</th>
                            <th scope="col">Medicaid ID</th>
                            <th scope="col">Due date</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let p of formLa.referralMemberList;
                              let i = index
                            ">
                            <td>{{ p.firstNm }}</td>
                            <td>{{ p.miNm }}</td>
                            <td>{{ p.lastNm }}</td>
                            <td>
                              {{
                              preference.dropDownValues ? p.suffixNm : ""
                              }}
                            </td>
                            <td>{{ p.ssnNum }}</td>
                            <td>{{ p.dobDt }}</td>
                            <td>
                              <ng-container *ngIf="p.gencd == 'F'">Female</ng-container>
                              <ng-container *ngIf="p.gencd == 'M'">Male</ng-container>
                            </td>
                            <td>{{ p.rshcd }}</td>
                            <td>{{ p.maNum }}</td>
                            <td>{{ p.dueDate }}</td>

                            <td>
                              <button mat-mini-fab color="warn" id="removeMember" (click)="removeMember(i)">
                                <span class="bi bi-trash"></span>
                              </button>
                              <button mat-mini-fab color="primary" id="editMember" (click)="editMember(i)">
                                <span class="bi bi-pencil-square"></span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row" *ngIf="isFamilyMemberMedicate == 'Yes'">
                    <mat-error *ngIf="additionalMembersReq">
                      At least one family member should be added.
                    </mat-error>
                    <mat-error *ngIf="additionalMaxReached">
                      Family member limit has reached to 50.
                    </mat-error>
                  </div>
                  <ng-container *ngIf="
                      isFamilyMemberMedicate == 'No' && isMemberMedicaid == 'No'
                    ">
                    <mat-card>
                      <mat-card-content>
                        <div class="alert alert-danger d-flex" role="alert">
                          <i class="bi bi-exclamation-triangle-fill px-2"></i>

                          At least one member of your family should be a
                          Medicaid recipient to apply for HIPP. Based on your
                          responses, you do not qualify for HIPP.
                        </div>
                      </mat-card-content>
                    </mat-card>
                    <br />
                  </ng-container>
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button mat-raised-button color="warn" matStepperPrevious
                      style="background-color: #b89d18; color: white" (click)="goBack2()">
                      Previous
                    </button>
                    <ng-container *ngIf="
                        !(
                          isFamilyMemberMedicate == 'No' &&
                          isMemberMedicaid == 'No'
                        )
                      ">
                      <button mat-raised-button color="primary" matStepperNext (click)="goForward2()">
                        Next
                      </button>
                    </ng-container>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step label="Rights and Responsibilities" aria-label="Rights and Responsibilities" [completed]="rightsResponsibilityCheck()">
                <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
                  <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
                    Rights and Responsibilities
                  </legend>

                  <div class="container-fluid">
                    <ul>
                      <li>
                        I understand that I am signing this application under
                        penalty of perjury, which means I&rsquo;ve provided true
                        answers to all the questions on this form to the best of
                        my knowledge. I know that I may be subject to penalties
                        under federal law if I provide false or untrue
                        information. I have permission from all of the people
                        listed on the application to both submit their
                        information to the Louisiana Department of Health (LDH)
                        and receive any information about their eligibility and
                        health coverage.
                      </li>
                      <li>
                        I understand that LDH is authorized to gather the
                        information requested in this application and any
                        supporting documentation, including social security
                        numbers, under the Patient Protection and Affordable
                        Care Act (Public Law No. 111-148), as amended by the
                        Health Care and Education Reconciliation Act of 2010
                        (Public Law No. 111-152), and the Social Security Act.
                      </li>
                      <li>
                        I understand that providing the requested information
                        (including social security numbers) is voluntary.
                        However, failing to provide it may delay or prevent me
                        from getting health coverage through Medicaid or any
                        other insurance affordability program.
                      </li>
                      <li>
                        I understand that LDH will check the information I give
                        them to make sure it is correct. I give LDH permission
                        to contact any outside source(s) necessary to check this
                        information, process my application, determine
                        eligibility, and otherwise operate the Medicaid program.
                        These outside sources may include:
                      </li>
                      <li>
                        Federal agencies (such as the Internal Revenue Service,
                        Social Security Administration, and Department of
                        Homeland Security), other state agencies, and/or local
                        government agencies.
                      </li>
                      <li>
                        Banks, financial institutions, and consumer reporting
                        agencies.
                      </li>
                      <li>
                        Employers identified on applications for eligibility
                        determinations.
                      </li>
                      <li>Doctors or other medical providers.</li>
                      <li>
                        Applicants, and authorized representatives of
                        applicants.
                      </li>
                      <li>
                        LDH contractors engaged to perform a function for the
                        Medicaid program.
                      </li>
                      <li>Anyone else as required or allowed by law</li>
                      <li>
                        I give these outside sources permission to give LDH any
                        information about me, or any person necessary for this
                        application, that it may request. I understand that this
                        permission will end when this application is denied,
                        when my Medicaid eligibility ends, or when I submit a
                        written statement to LDH canceling this permission,
                        whichever comes first. A cancellation may prevent me
                        from being found to be eligible for Medicaid.
                      </li>
                      <li>
                        I understand the social security numbers will only be
                        used to get information from these outside sources to
                        verify income, make eligibility determinations, or for
                        other purposes directly connected to the administration
                        of the Medicaid program.
                      </li>
                      <li>
                        I know that I must tell Medicaid if anything changes
                        (and is different than) what I wrote on this
                        application. I can visit www.medicaid.la.gov or call
                        1-888-342-6207 to report any changes. I understand that
                        a change in my information could affect the eligibility
                        for member(s) of my household.
                      </li>
                      <li>
                        I know that under federal law, discrimination
                        isn&rsquo;t permitted on the basis of race, color,
                        national origin, sex, age, sexual orientation, gender
                        identity, or disability. I can file a complaint of
                        discrimination by visiting www.hhs.gov/ocr/office/file,
                        calling the US DHHS Regional Office for Civil Rights at
                        1-800-368-1019, or writing to the LDH at PO Box 4818,
                        Baton Rouge, Louisiana 70821.
                      </li>
                      <li>
                        I confirm that no one applying for health insurance on
                        this application is incarcerated (detained or jailed),
                        and if they are that I must report it.&nbsp;
                      </li>
                    </ul>
                    <h4>
                      <strong>If anyone on this application is eligible for
                        Medicaid</strong>
                    </h4>
                    <p>
                      By signing and submitting this application, I understand
                      that if anyone on this application enrolls in Medicaid,
                      I&rsquo;m giving LDH our rights to any money owed to us by
                      any other health insurance, legal settlement, a spouse or
                      parent, or other third party.
                    </p>
                    <h4><strong>Estate Recovery</strong></h4>
                    <p>
                      I understand that Estate Recovery rules require Louisiana
                      Medicaid to recover the cost of certain Medicaid payments
                      from the applicant&rsquo;s estate. These costs include the
                      total amount of payments for facility services, hospital
                      care, payments to HCBS or PACE providers, and prescription
                      drugs received at age 55 or older. The estate is the
                      property owned at the time of death.
                    </p>
                    <p>
                      Medicaid will not make a claim against the estate while
                      the applicant or his or her legal spouse is still living.
                      Medicaid also will not make a claim if the applicant has a
                      dependent child who is under age 21, blind, or disabled.
                      Collection may not be made if it is not cost effective for
                      Medicaid to do so, or if it would cause a hardship for the
                      heirs of the estate. A hardship may exist if the estate
                      property is the only source of income for the heirs, if
                      that income is limited, or if there are other convincing
                      situations.
                    </p>
                    <h4><strong>My right to appeal</strong></h4>
                    <p>
                      If I think Louisiana Medicaid has made a mistake, I can
                      appeal its decision. To appeal means to tell someone at
                      Medicaid that I think the action is wrong, and ask for a
                      fair review of the action. I know that I can find out how
                      to appeal by contacting Medicaid at 1-888-342-6207. I know
                      that I can be represented in the process by someone other
                      than myself. My eligibility and other important
                      information will be explained to me.
                    </p>
                  </div>
                  <br />

                  <section class="example-section" required>
                    <mat-slide-toggle color="primary" class="example-margin" name="signReadCheck"
                      [(ngModel)]="signReadCheck" #signReadChecked="ngModel" [required]="signCheckRequired"><span
                        class="text-danger">*</span> Please slide the
                      toggle button to let us know that you have read your
                      Rights and Responsibilities</mat-slide-toggle>
                  </section>
                  <mat-error *ngIf="signReadChecked.errors?.['required'] && customerForm.submitted">Your response is
                    required</mat-error>

                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button mat-raised-button color="warn" matStepperPrevious (click)="clear($event)"
                      style="background-color: #b89d18; color: white">
                      Previous
                    </button>
                    <button mat-raised-button color="primary" matStepperNext (click)="goForward3()">
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step label="Voter Registration" aria-label="Voter Registration" [completed]="voterRegistrationCheck()">
                <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
                  <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
                    Voter Registration Options
                  </legend>

                  <div class="container-fluid">
                    <p>
                      If you are not registered to vote where you live now, you
                      may register today!
                    </p>
                    <p>&nbsp;Ways to register:</p>
                    <ul>
                      <li>
                        Online: by visiting
                        <a [href]="voteLink" target="_blank" role="presentation"
                          aria-label="Elections & Voting" lang="en"
                          alt="Elections & Voting">www.geauxvote.com</a>.&nbsp; A valid Louisiana driver&rsquo;s license
                        or ID
                        card is required.
                      </li>
                      <li>
                        By mail: You may click
                        <a style="color: #0c69f2;" lang="en" href="javascript:void(0)" (click)="openVoterForm()" 
                        target="_blank" lang="en" alt="Voter Registration form"
                        title="Voter Registration form" role="presentation" type="application/pdf">here</a>
                        to print and mail the Mail Voter Registration
                        Application.
                      </li>
                      <li>
                        You may also call 1-888-342-6207 to have a Voter
                        Registration Application mailed to you.
                      </li>
                    </ul>
                    <p>
                      Applying to register or declining to register to vote will
                      not affect the amount of assistance that you will be
                      provided by this agency.
                    </p>
                    <p>
                      If you would like help in filling out the voter
                      registration application form, we will help you.&nbsp; You
                      may call us toll-free at 1-888-342-6207. The decision
                      whether to seek or accept help is yours.&nbsp; You may
                      fill out the application form in private.
                    </p>
                    <p>
                      If you choose to register to vote at this time, the
                      information about the location where you completed the
                      application to register will remain confidential and will
                      only be used for voter registration purposes.&nbsp; If you
                      choose not to register to vote, that information will also
                      be kept confidential.
                    </p>
                    <p>
                      If you believe that someone has interfered with your right
                      to register or to decline to register to vote, your right
                      to privacy in deciding whether to register or in applying
                      to register to vote, or your right to choose your own
                      political party or other political preference, you may
                      file a complaint with:
                    </p>
                    <p class="ms-5">
                      Louisiana Secretary of State <br />
                      Commissioner of Elections<br />
                      P.O. Box 94125<br />
                      Baton Rouge, LA 70804-9125<br />
                      Phone: (toll-free) 1-800-883-2805
                    </p>
                    <br />
                    <br />
                    <br />
                  </div>
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button mat-raised-button color="warn" matStepperPrevious
                      style="background-color: #b89d18; color: white">
                      Previous
                    </button>
                    <button mat-raised-button color="primary" matStepperNext (click)="goForward4()">
                      Next
                    </button>
                  </div>
                </fieldset>

                <br />
              </mat-step>
               <mat-step label="Submit" aria-label="Submit" [completed]="submitCheck()">
                <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
                  <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
                    Electronic Signature Agreement
                  </legend>

                  <div class="container-fluid">
                    <br />
                    <div>
                      <h4><strong>ELECTRONIC SIGNATURE</strong></h4>
                      <br />
                      <p>
                        I certify under penalty of perjury that the information
                        I have given on this application is true, complete, and
                        correct to the best of my knowledge, including the
                        information I have given regarding the U.S. citizenship
                        or immigration status of all household members. I
                        understand that I and any adult household member will be
                        subject to disqualification and prosecution and will be
                        required to repay ineligible benefits or services if we
                        knowingly give false, incorrect, or incomplete
                        information in order to obtain or try to obtain health
                        care assistance. By signing this application, I give
                        permission for the release of information to the
                        Louisiana Department of Health by any persons or
                        agencies who have knowledge of my circumstances.
                      </p>
                    </div>
                    <br />
                    <section class="example-section" required>
                      <mat-slide-toggle color="primary" class="example-margin" name="signElectronicSignatureChecked"
                        #signElectronicCheck="ngModel" [(ngModel)]="signElectronicSignatureChecked"
                        [required]="signElectronicRequired"><span class="text-danger">*</span> Please slide the
                        toggle button to let us know that you have read the
                        “Electronic Signature Agreement”.</mat-slide-toggle>
                    </section>
                    <mat-error *ngIf="signElectronicCheck.errors?.['required'] && customerForm.submitted">Your response
                      is required</mat-error>

                    <br />
                    <br />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <div class="row">
                          <div class="col">
                            <mat-label><span class="text-danger">*</span> Please
                              select the correct description of the person
                              signing this application:</mat-label>
                          </div>
                        </div>
                      </mat-card-header>
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-radio-group #group color="primary" class="example-radio-group"
                              [(ngModel)]="signApplicant" [required]="signApplicantRequired" name="signApplicant"
                              #signApplicat="ngModel" (click)="signApplicantCheck()">
                              <mat-radio-button #buttons class="example-radio-button" value="self"
                                [required]="signApplicantRequired">
                                I am the applicant signing for myself
                              </mat-radio-button>
                              <mat-radio-button #buttons class="example-radio-button" value="onbehalf"
                                [required]="signApplicantRequired">
                                I am signing on the applicant’s behalf
                              </mat-radio-button>
                            </mat-radio-group>
                            <mat-error *ngIf="signApplicat.errors?.['required'] && customerForm.submitted">Your response
                              is required</mat-error>
                          </div>
                          <div class="col"></div>
                          <div class="col"></div>
                        </div>
                        <br />

                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>First Name<ng-container
                                  *ngIf="!signfirstNmRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="signfirstNm" [(ngModel)]="
                                    formLa.referralCase.submitterFirstName
                                  " maxlength="20" #signFN="ngModel" [required]="signfirstNmRequired" uppercase
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                (keypress)="allowAlphabets2($event, signFN)" (blur)="nomatchCheck($event, signFN)" />
                              <mat-error *ngIf="signFN.errors?.['required'] && !signFN.errors?.['nomatch']">First Name
                                is required</mat-error>
                              <mat-error *ngIf="signFN.errors?.['invalid']">First Name is invalid</mat-error>
                              <mat-error *ngIf="signFN.errors?.['pattern']">First Name is invalid</mat-error>
                              <mat-error *ngIf="signFN.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Last Name<ng-container
                                  *ngIf="!signLastNameRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="signLastName" [(ngModel)]="
                                    formLa.referralCase.submitterLastName
                                  " maxlength="20" #signLN="ngModel" [required]="signLastNameRequired" uppercase
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                (keypress)="allowAlphabets2($event, signLN)" (blur)="nomatchCheck($event, signLN)" />
                              <mat-error *ngIf="signLN.errors?.['required'] && !signLN.errors?.['nomatch']">Last Name is
                                required</mat-error>
                              <mat-error *ngIf="signLN.errors?.['invalid']">Last Name is invalid</mat-error>
                              <mat-error *ngIf="signLN.errors?.['pattern']">Last Name is invalid</mat-error>
                              <mat-error *ngIf="signLN.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <mat-card class="mat-elevation-z8">
                      <mat-card-content>
                        <div class="text-center">
                          <div class="row">
                            <div class="col text-danger text-center fw-semibold">
                              Enter the characters shown below into the box provided
                              before clicking Submit.
                            </div>
                          </div>
                          <br />

                          <div class="row text-center align-items-center">
                            <div class="col-4"></div>

                            <div class="col-4 d-flex">
                              <div class="p-3 text-white rounded fs-1 fw-bold fst-italic"
                                style="background-image: url('app/module/pierhippla/assets/img/capcha7.jpg');
                                   background-size: cover; flex: 2.5; display: flex; align-items: center; justify-content: center;">
                                {{ captchaText }}
                              </div>
                              <div class="d-flex flex-column justify-content-start ms-4" style="flex: 1;">
                                <div class="d-flex flex-column" style="flex: 1;">
                                  <div class="d-flex align-items-center mb-3"
                                    style="flex-grow: 0; flex-shrink: 1; flex-basis: 30px;">
                                    <i class="material-icons"
                                      style="font-size: 2.6rem; color: #007bff; cursor: pointer;"
                                      (click)="playCaptchaAudio()" title="Play Audio">
                                      volume_up
                                    </i>
                                    <span class="ms-2" style="font-size: 1rem;">Play Audio</span>
                                  </div>
                                  <div class="d-flex align-items-center"
                                    style="flex-grow: 0; flex-shrink: 1; flex-basis: 30px;">
                                    <i class="material-icons"
                                      style="font-size: 2.6rem; color: #28a745; cursor: pointer;"
                                      (click)="generateCaptcha()" title="Refresh Captcha">
                                      refresh
                                    </i>
                                    <span class="ms-2" style="font-size: 1rem;">Refresh Captcha</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-4"></div>
                          </div>
                          <br />

                          <div class="row">
                            <div class="col"></div>
                            <div class="col">
                              <mat-form-field appearance="outline">
                                <mat-label>Captcha<ng-container *ngIf="!captchaRequired">*</ng-container></mat-label>
                                <input matInput type="text" name="captcha" [(ngModel)]="captchaEntered"
                                  #captcha="ngModel" [required]="captchaRequired" (blur)="checkCaptch($event)"
                                  minlength="6" maxlength="6" />
                                <mat-error *ngIf="captcha.errors?.['required']">Captcha code is required</mat-error>
                                <mat-error *ngIf="captcha.errors?.['nomatch']">Captcha code does not match</mat-error>
                              </mat-form-field>
                            </div>
                            <div class="col"></div>
                          </div>
                          <div class="row justify-content-md-center">
                            <div class="col">
                              <button mat-raised-button color="warn" matStepperPrevious class="m-2"
                                style="background-color: #b89d18; color: white" (click)="goBack5()">
                                Previous
                              </button>

                              <button mat-raised-button color="primary" id="formSubmit" type="submit" class="m-2"
                                [disabled]="
                              customerForm.pristine || !customerForm.valid
                            " (click)="goForward5()">
                                {{ operationText }}
                              </button>
                              <button mat-raised-button id="formReset" class="m-2" type="button" [disabled]="
                              customerForm.pristine || !customerForm.valid
                            " (click)="cancel($event)">
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                  <br />

                  <div class="alert alert-danger" *ngIf="errorMessage">
                    {{ errorMessage }}
                  </div>

                  <br />
                </fieldset>
              </mat-step>
              <br />
            </mat-horizontal-stepper>
          </div>
        </form>
      </div>
    </div>
    <div class="form-bg" *ngIf="isValidFormSubmitted">
      <ng-container *ngIf="submittedResponse.referralId != undefined">
        <div class="row">
          <div class="col">
            <app-timer-la [isValidFormSubmitted]="isValidFormSubmitted"
              (changeResetMessageCalled)="changeResetMessage()"></app-timer-la>

            <br />
          </div>
        </div>
        <div class="container-fluid rounded p-3 bg-light" style="border: 2px solid #63b1bc">
          <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
            <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #0f6db7">
              Your LaHIPP application has been submitted
            </legend>

            <div class="container">
              <p class="fw-bold text-center">
                Confirmation ID : {{ submittedResponse.referralId }}
              </p>
              <p>
                Your application has been submitted successfully.
                <a [href]="downloadLink" (click)="openPdf()" title="Submitted Form" role="presentation"
                  type="application/pdf" aria-label="Submitted Form" lang="en" alt="Submitted Form">Download Form</a>
                to print the submitted application for your records. We will
                contact you to let you know if we need additional information to
                confirm your eligibility.
              </p>
            </div>
          </fieldset>
          <br />
          <br />
          <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
            <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
              Register for Premium Reimbursement
            </legend>

            <div class="container">
              <p class="fw-bold">
                If your application is approved, you will be eligible to receive
                premium reimbursement.
              </p>
              <p class="fw-bold">
                You must complete and submit the following documents to receive
                reimbursement:
              </p>
              <br />
              <br />
              <ul class="fw-bold">
                <li>
                  Download and complete the
                  <a style="color: #0c69f2;" lang="en" href="javascript:void(0)" (click)="openW9Form()" title="W9 form"
                   download>W-9 Form</a>
                </li>
                <li>
                  Download and complete the
                  <a style="color: #0c69f2;" lang="en" href="javascript:void(0)" (click)="openEFTForm()" title="EFT form"
                   download>Electronic Funds Transfer (EFT) Form</a>
                </li>
              </ul>
              <br />
              <br />
              <div class="text-center text-secondary fw-bold">
                Send completed forms in one of the following ways:
              </div>
              <br />
              <div class="text-center fw-bold">
                Email:
                <a target="_blank" [href]="emailTo" alt="email" role="link">{{
                  email
                  }}</a>
                | Fax: {{ faxNo }} | Mail to: {{ address }}
              </div>
              <br />
              <br />
            </div>
          </fieldset>
        </div>
      </ng-container>
      <ng-container *ngIf="submittedResponse.referralId == undefined">
        <div class="container text-center text-danger-emphasis bg-danger-subtle rounded-3">
          <br />
          <p class="fs-1"><i class="bi bi-exclamation-circle-fill "></i></p>
          <ng-container *ngIf="apiError && apiError.status == 500">
            <h1>Something Went Wrong</h1>
            <h4>Sorry! Your request could not be processed as something went wrong on our side.</h4>
            <h4>{{getMessageServerDown()}}</h4>
          </ng-container>
          <ng-container *ngIf="apiError && apiError.status != 500">
            <h1>Error occured from server side <strong> {{apiError.status}} {{apiError.statusText}}</strong> </h1>
            <h4>Your request could not be processed due to below error</h4>
            <p>
              <ng-container *ngIf="apiError.error.detail">{{apiError.error.detail}}</ng-container>
              <ng-container *ngIf="!apiError.error.detail">{{apiError.message}}</ng-container>
            </p>
          </ng-container>
          <br />
        </div>
      </ng-container>

    </div>
  </mat-card-content>
</mat-card>